<template>
  <div>
    <base-card>
      <h1>Data Export</h1>
      <base-card>
        <h2>Seasons ({{ allSeasons.length }})</h2>
        <textarea
          v-model="stringifiedSeasons"
          name="exportdata-seasons"
          id="exportdata-seasons"
          style="width: 100%"
          rows="5"
          readonly
        ></textarea>
      </base-card>
      <base-card>
        <h2>Schedules ({{ allSchedules.length }})</h2>
        <textarea
          v-model="stringifiedSchedules"
          name="exportdata-schedules"
          id="exportdata-schedules"
          style="width: 100%"
          rows="10"
          readonly
        ></textarea>
      </base-card>
      <base-card>
        <h2>Users ({{ allUsers.length }})</h2>
        <textarea
          v-model="stringifiedUsers"
          name="exportdata-users"
          id="exportdata-users"
          style="width: 100%"
          rows="5"
          readonly
        ></textarea>
      </base-card>
      <base-card>
        <h2>Picks ({{ allPicks.length }})</h2>
        <textarea
          v-model="stringifiedPicks"
          name="exportdata-picks"
          id="exportdata-picks"
          style="width: 100%"
          rows="10"
          readonly
        ></textarea>
      </base-card>
      <base-card>
        <h2>All Database Data ({{ dataLength }})</h2>
        <textarea
          v-model="stringifiedData"
          name="exportdata"
          id="exportdata"
          style="width: 100%"
          rows="20"
          readonly
        ></textarea>
      </base-card>
    </base-card>
  </div>
</template>

<script>
export default {
  computed: {
    allSeasons() {
      return this.$store.getters["seasons/seasonsList"];
    },
    allSchedules() {
      return this.$store.getters["schedules/schedulesList"];
    },
    allUsers() {
      return this.$store.getters["userProfiles"];
    },
    allPicks() {
      return this.$store.getters["picks/allPicksList"];
    },
    stringifiedData() {
      const allData = {
        exportdate: (new Date()).toJSON(),
        seasons: this.allSeasons,
        schedules: this.allSchedules,
        users: this.allUsers,
        picks: this.allPicks,
      };

      return JSON.stringify(allData);
    },
    stringifiedSeasons() {
      return JSON.stringify(this.allSeasons);
    },
    stringifiedSchedules() {
      return JSON.stringify(this.allSchedules);
    },
    stringifiedUsers() {
      return JSON.stringify(this.allUsers);
    },
    stringifiedPicks() {
      return JSON.stringify(this.allPicks);
    },
    dataLength() {
      return (this.stringifiedData.length / 1024).toLocaleString(
        undefined, // leave undefined to use the visitor's browser 
                   // locale or a string like 'en-US' to override it.
        { minimumFractionDigits: 1, maximumFractionDigits: 1 }) + "KB";
    },
  },
};
</script>